import React, { useMemo, ReactNode, createContext, useContext } from "react";

import { AppPermissionMasterRaw } from "@/domain/AppPermissionMaster";
import { useAdminAPI } from "../hooks";

const ctx = createContext<{
  appPermissionMasters: AppPermissionMasterRaw[] | null;
  runReloadAppPermissionMasters: () => Promise<void>;
  isLoadedAppPermissionMasters: boolean;
}>({
  appPermissionMasters: null,
  runReloadAppPermissionMasters: async () => {
    // nop
  },
  isLoadedAppPermissionMasters: false,
});

export const AdminAppPermissionMastersProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const {
    state: appPermissionMasters,
    runReloadState: runReloadAppPermissionMasters,
    isLoadedState: isLoadedAppPermissionMasters,
  } = useAdminAPI<AppPermissionMasterRaw[]>("appPermissionMasters");

  const ctxValue = useMemo(
    () => ({
      appPermissionMasters,
      runReloadAppPermissionMasters,
      isLoadedAppPermissionMasters,
    }),
    [
      appPermissionMasters,
      runReloadAppPermissionMasters,
      isLoadedAppPermissionMasters,
    ]
  );

  return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
};

export const useAdminAppPermissionMasters = () => {
  return useContext(ctx);
};
